import { inject } from '@angular/core';
import { HttpEvent, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { EncDecCryptoService } from '@core/crypto-module/encDecCryptoService.service';
import { ENCRYPTION_MODE } from './encryption-mode';

export const encryptionInterceptor: HttpInterceptorFn = (req, next) => {
  const encService = inject(EncDecCryptoService);
  const encryptionMode = inject(ENCRYPTION_MODE).get();

  const shouldEncrypt =
    encryptionMode === 1 &&
    !req.url.includes('site-settings') &&
    req.method !== 'GET';
  console.log(req.body);

  // encrypt request body
  if (shouldEncrypt && req.body) {
    const encrypted = encService.encrypt(req.body);
    req = req.clone({
      body: encrypted.data,
      setHeaders: { reqiv: encrypted.iv }
    });
  }

  // decrypt response body
  return next(req).pipe(
    map((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse && shouldEncrypt) {
        try {
          const decrypted = encService.decrypt(event.body.body, event.body.respiv);
          console.log(decrypted);

          return event.clone({ body: decrypted.original });
        } catch {
          return event;
        }
      }
      return event;
    })
  );
};
